import * as Yup from "yup";
import Login from "../../Entity/Login/Login";
import firebaseConfig from "@serie3/freelancesplaceapi/Config/Firebase/firebase";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInWithEmailAndPassword,
} from "firebase/auth";

const validationSchema = Yup.object().shape({
  username: Yup.string().required().email().label("Email"),
  password: Yup.string().required().min(4).label("Password"),
});

const CreateLoginForm = (showLoginError, closeModal) => {
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  return {
    initialValues: Login,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        await signInWithEmailAndPassword(
          auth,
          values.username,
          values.password
        );

        if(typeof closeModal !== "undefined"){
          closeModal();
        }
      } catch (error) {
        console.log(`There was an error: ${error}`);
        showLoginError(true);
      }
    },
  };
};

export default CreateLoginForm;
